"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.isDefaultProfileImage = isDefaultProfileImage;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledIs = _interopRequireWildcard(require("../../utils/styled-is"));
var _HBMediaElement = require("../HBMediaElement/HBMediaElement");
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var sizes = {
  xs: {
    avatarSize: 16,
    textType: 'emphasis10'
  },
  sm: {
    avatarSize: 24,
    textType: 'emphasis10'
  },
  md: {
    avatarSize: 32,
    textType: 'emphasis12'
  },
  lg: {
    avatarSize: 40,
    textType: 'emphasis14'
  },
  xl: {
    avatarSize: 80,
    textType: 'emphasis24'
  }
};
var getAvatarUrlTransformation = function getAvatarUrlTransformation(_ref) {
  var imageSize = _ref.imageSize,
    profileImageUrl = _ref.profileImageUrl;
  var path = (0, _HBMediaElement.getCloudinaryPathFromCloudinaryUrl)(profileImageUrl);
  var avatarTransformations = [{
    flags: 'lossy',
    crop: 'lfill',
    width: imageSize,
    height: imageSize,
    quality: 'auto:best',
    fetch_format: 'auto'
  }, {
    dpr: 2
  }];
  return (0, _HBMediaElement.generateUrl)({
    path: path,
    transformations: avatarTransformations
  });
};
function isDefaultProfileImage(profileImageUrl) {
  return !profileImageUrl || profileImageUrl.includes('/honeybook_cdn/assets_users_production/users/') || profileImageUrl.includes('assets_users_production/users/empty_default_image.png') || profileImageUrl.includes('assets_users_production/users/sample_user/profilepic180x180.png');
}
var HBAvatar = function HBAvatar(_ref2) {
  var className = _ref2.className,
    size = _ref2.size,
    diameterInPixels = _ref2.diameterInPixels,
    profileImageUrl = _ref2.profileImageUrl,
    testId = _ref2.testId,
    userInitials = _ref2.userInitials;
  var imageSize = diameterInPixels || 64;
  var textType = 'title20';
  var _userInitials = userInitials || '';
  if (size) {
    imageSize = sizes[size].avatarSize;
    textType = sizes[size].textType;
  }
  var imageUrl = profileImageUrl && !isDefaultProfileImage(profileImageUrl) ? getAvatarUrlTransformation({
    imageSize: imageSize,
    profileImageUrl: profileImageUrl
  }) : undefined;
  var userInitialsToShow = (size === 'xs' ? _userInitials.charAt(0) : _userInitials).toUpperCase();
  return /*#__PURE__*/_react["default"].createElement(Container, {
    className: className,
    "data-testid": testId,
    $isUpToSmallSize: size === 'xs' || size === 'sm',
    $imageSize: imageSize,
    $profileImageUrl: imageUrl
  }, !imageUrl && /*#__PURE__*/_react["default"].createElement(StyledText, {
    color: "neutral900",
    type: textType,
    $diameterInPixels: diameterInPixels
  }, userInitialsToShow));
};
var _default = exports["default"] = HBAvatar; // -------------------------------- Styles -------------------------------- //
var Container = _styledComponents["default"].div.withConfig({
  displayName: "HBAvatar__Container",
  componentId: "sc-1q8zztr-0"
})(["border-radius:50%;box-sizing:border-box;border:2px solid ", ";width:", "px;height:", "px;min-width:", "px;display:inline-flex;justify-content:center;align-items:center;", " ", " ", ""], _colors["default"].white, function (props) {
  return props.$imageSize;
}, function (props) {
  return props.$imageSize;
}, function (props) {
  return props.$imageSize;
}, (0, _styledIs["default"])('$isUpToSmallSize')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n        border-width: 1px;\n    "]))), (0, _styledIs["default"])('$profileImageUrl')(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n        background-position: center;\n        background-position: center; /* Do not remove this duplicate. This is fixing a very weird bug */\n        background-size: cover;\n        background-image: url(", ");\n    "])), function (props) {
  return props.$profileImageUrl;
}), (0, _styledIs.isNot)('$profileImageUrl')(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n        background-color: ", ";\n    "])), _colors["default"].neutral400));
var StyledText = (0, _styledComponents["default"])(_HBText["default"]).withConfig({
  displayName: "HBAvatar__StyledText",
  componentId: "sc-1q8zztr-1"
})(["", ""], function (props) {
  return props.$diameterInPixels ? "font-size: ".concat(props.$diameterInPixels / 2, "px;") : '';
});
//# sourceMappingURL=HBAvatar.js.map